// Shared file-validation helpers — extracted from JobApplicationModal so they
// can be unit-tested in isolation and reused by any future upload form.

export const MAX_SIZE = 5 * 1024 * 1024;
export const RESUME_EXTS = ['.pdf', '.doc', '.docx'];
export const ADDITIONAL_EXTS = ['.pdf', '.doc', '.docx', '.txt', '.png', '.jpg', '.jpeg'];

export function fileExt(name) {
  return ('.' + (name || '').split('.').pop()).toLowerCase();
}

export function validateFile(file, allowedExts, maxSize = MAX_SIZE) {
  if (!file) return 'File is required';
  if (!allowedExts.includes(fileExt(file.name))) {
    return `Unsupported format. Allowed: ${allowedExts.join(', ')}`;
  }
  if (file.size > maxSize) {
    return `File too large (max ${maxSize / 1024 / 1024} MB)`;
  }
  if (file.size === 0) return 'File is empty';
  return null;
}
